<div class="container">
  @if (this.isLoadingEditStakeholder()) {
    <app-loading-spinner-overlay
      [isLoading]="true"
      [screenReaderText]="'Registering stakeholder.'"
    ></app-loading-spinner-overlay>
  }
  <h1>
    @if (projectName) {
      <span>
        {{ projectName }}
      </span>
    } @else {
      Project Name
    }
  </h1>
  <h3>
    @if (meetingName) {
      <span> Register for {{ meetingName }} </span>
    }
  </h3>
  <div class="step" aria-live="polite">
    <p>
      You were not found in our records. Please enter additional information to register for the
      @if (registrationMode === 'survey123') {
        survey
      } @else {
        meeting
      }
      .
    </p>
  </div>

  <app-global-edit-stakeholder
    [projectInfo]="projectInfo"
    [stakeholderInfo]="stakeholderInfo"
    [isEdit]="isEdit"
    [goBackUrl]="backUrl"
    (formResult)="handleStakeholderEditCreateResult($event)"
  ></app-global-edit-stakeholder>
</div>
